'use client'

import { useEffect } from 'react'
import { useCookies } from 'next-client-cookies'
import { useMeStore, useCartStore } from '@/store'

/**
 * UserInitializer - Initializes user state on client-side without affecting SSR
 * This component renders nothing but runs a side effect to fetch user data if the token exists
 */
const UserInitializer = () => {
  const cookies = useCookies()
  const { meState, getMe } = useMeStore()
  const { cartState, getCart } = useCartStore()
  const { response: user, isLoading } = meState
  const hasToken = !!cookies.get('accessToken')

  useEffect(() => {
    if (hasToken && !user && !isLoading) {
      getMe().catch(() => {})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (hasToken && !cartState.response && !cartState.isLoading) {
      getCart().catch(() => {})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default UserInitializer
